import { createContext, useContext, useState } from 'react';
import axios from 'axios';

import { API_URL } from 'utils/config';

const MacrobenthosContext = createContext();
export const useMacrobenthosContext = () => useContext(MacrobenthosContext);

const EMPTY_SITE_DATA = {
  id: 0,
  year: '',
  site: '',
  month: '',
  cw: '',
  mm: '',
  sc: '',
  co: '',
  s_temp: '',
  t_sal: '',
  s_ph: '',
};

export const MacrobenthosProvider = ({ children }) => {
  const [sites, setSites] = useState([]);
  const [activeSite, setActiveSite] = useState('');
  const [activeSiteData, setActiveSiteData] = useState(EMPTY_SITE_DATA);
  const [siteMacrobenthosSeries, setSiteMacrobenthosSeries] = useState([]);
  const [graphData, setGraphData] = useState([]);

  const getSiteList = async () => {
    try {
      const response = await axios.get(`${API_URL}/getCrabSites`);
      const result = response.data;
      setSites([...result]);
    } catch (err) {
      console.log(err);
    }
  };

  const getSiteContent = async () => {
    setActiveSiteData({ ...EMPTY_SITE_DATA });

    try {
      const response = await axios.get(
        `${API_URL}/getBenthicOrganisms?site=${activeSite}`
      );
      const result = response.data[response.data.length - 1];

      if (!result) {
        setActiveSiteData({ ...EMPTY_SITE_DATA });
        return;
      }

      const matchKey = Object.keys(EMPTY_SITE_DATA).reduce((target, key) => {
        if (key in result) {
          target[key] = result[key];
        }
        return target;
      }, {});
      setActiveSiteData({ ...matchKey });
    } catch (err) {
      console.log(err);
    }
  };

  const getSiteMacrobenthosSeries = async () => {
    setSiteMacrobenthosSeries([]);

    try {
      const response = await axios.get(
        `${API_URL}/getCrabs?site=${activeSite}`
      );
      setSiteMacrobenthosSeries([...response.data]);
    } catch (err) {
      console.log(err);
    }
  };

  const contextData = {
    sites,
    activeSite,
    setActiveSite,
    activeSiteData,
    graphData,
    setGraphData,
    siteMacrobenthosSeries,
    getSiteList,
    getSiteContent,
    getSiteMacrobenthosSeries,
  };

  return (
    <MacrobenthosContext.Provider value={contextData}>
      {children}
    </MacrobenthosContext.Provider>
  );
};
